import React from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import './style.scoped.scss';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../assets/constants/strings';
import { Button } from 'react-bootstrap';
import { HiPlusCircle } from 'react-icons/hi';

const UserInfo = ({
  className,
  title,
  percentage,
  progressBarText,
  icon,
  iconId,
  barId,
  showBtn = false,
  showQueriesBtn = false,
  handleClick,
  showOverlay = false,
  overlayText,
  isSmallScreen = false,
}) => {
  return (
    <div
      className={`userInfo ${className ? className : ''} ${
        showOverlay ? 'overlay' : ''
      }`}
      style={{ marginRight: isSmallScreen ? '7px' : '' }}
    >
      <div className={`userInfo__info ${showOverlay ? 'overlay' : ''}`}>
        {showOverlay && (
          <div className='overlay__inside'>
            <p>
              <strong>{overlayText}</strong>
            </p>
            <Button className='moreQueriesBtn'>
              <Link to={ROUTES.USAGE}>View Usage</Link>
            </Button>
          </div>
        )}
        <span
          className='userInfo__icon'
          id={iconId}
          style={{ opacity: showOverlay ? 0.4 : 1 }}
        >
          {icon}
        </span>
        <div className='userInfo__stats'>
          <b>{title}</b>
          <div className='userInfo__progressBar'>
            {progressBarText}
            <ProgressBar className={barId} now={percentage} />
          </div>
          {showBtn && (
            <>
              <p className='mt-2 mb-0 py-0'>
                Upgrade Plan to access more regulations
              </p>
              <Button className='updateSubsBtn'>
                <Link to={ROUTES.UPGRADE}>Update Subscription</Link>
              </Button>
            </>
          )}
          {showQueriesBtn && (
            <>
              <p className='mt-2 mb-0 p-0'>Get more AI query credits</p>
              <Button className='moreQueriesBtn' onClick={handleClick}>
                <HiPlusCircle />
                <span className='ml-2'>Buy more AI queries</span>
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
